export default __webpack_public_path__ + "images/Tapclicks.04b413df777aacd0dcb0674da706e82f.svg";